module.exports = __webpack_public_path__ + "static/media/parceiro4.a2b02978.png";